(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rifthaus-hori-product-story"] && !Shopify.designMode) return;
  try {
    
  (() => {
    document.querySelectorAll('.rh-hori:not([data-rh-ready])').forEach((section) => {
      section.dataset.rhReady = 'true';
      section.querySelectorAll('[data-rh-scroll]').forEach((button) => {
        button.addEventListener('click', () => {
          const productForm = document.querySelector('main form[action*="/cart/add"]');
          if (!productForm) return;
          productForm.scrollIntoView({ behavior: 'smooth', block: 'center' });
          const firstOption = productForm.querySelector('input, select, button');
          if (firstOption) firstOption.focus({ preventScroll: true });
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
